export default "__VITE_ASSET__CxmV_gor__"